import axios from "axios";

/**
 *
 * @param {function} callback
 * function that is passed in to on completion of this AJAX call
 * @param {string} address 
 * string that is passed to AJAX call
 * 
 */

const ADDRESS_KEY = window.autoAddressKey;
const ADDRESS_URL = window.autoAddressBaseUrl;

const autoCompleteAddress = (address, callback) => {
    axios.get(`${ADDRESS_URL}/autocomplete?key=${ADDRESS_KEY}&address=${address}&addressProfileName=AnPostShop&vanityMode=false`).then(response => {
        callback(response);
    });
};

const findAddress = (address, callback, customUrl) => {
    if (customUrl) {
        axios.get(customUrl).then(response => {
            callback(response);
        });
    } else {
        axios.get(`${ADDRESS_URL}/findaddress?key=${ADDRESS_KEY}&address=${address}&vanityMode=false&addressProfileName=AnPostShop&language=EN&limit=-1`).then(response => {
            callback(response);
        });
    }

};

export { autoCompleteAddress, findAddress };
